<template>
  <div v-if="showing">
    <Modal>
      <div class="modal-layout">
        <div class="header">
          <div></div>
          <div class="middle">Close Study</div>
          <div class="right" @click="closeModal">
            <Fai :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="content">Are you sure you want to close this study?</div>
        <div class="button-row">
          <button class="pure-button bigmi-cyan-blue-2-button each-button" @click="closeModal">
            <span>Cancel</span>
          </button>
          <button class="pure-button bigmi-red-2-button each-button" @click="confirmCloseSurvey">
            <Fai v-if="loading" :icon="['far', 'circle-notch']" spin />
            <span v-else>Confirm</span>
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ConfirmCloseStudyModal",
  props: {
    showing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeModal() {
      this.$emit("hide");
    },
    confirmCloseSurvey() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main";
.modal-layout {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 3px;

  .header {
    display: grid;
    grid-template-columns: 15% 70% 15%;
    padding: 10px 10px;

    .left {
    }

    .middle {
      justify-self: center;
      color: $red-2;
      font-size: 20px;
      font-weight: 900;
    }

    .right {
      justify-self: right;
      font-size: 20px;
    }

    .right:hover {
      cursor: pointer;
    }
  }

  .content {
    padding: 20px 10px;
    line-height: 1.2;
  }

  .button-row {
    display: flex;
    justify-content: space-around;
    padding-top: 20px;

    .each-button {
      flex-basis: 33%;
    }
  }
}
</style>
